import React from "react";
import { FormControl } from "react-bootstrap";
import SurveyField from "../../components/SurveyField";

const RatingQuestionFields = ({ question, readOnly, update, inspector }) => (
  <div className={`survey-engine-form-grid survey-engine-rating-grid ${inspector ? "survey-engine-inspector-grid" : ""}`}>
    <SurveyField label="Rating style" required>
      <FormControl componentClass="select" value={question.ratingStyle || "stars"} disabled={readOnly} onChange={(event) => update("ratingStyle", event.target.value)}>
        <option value="stars">Stars</option><option value="scale">Scale</option><option value="emoji">Emoji</option>
      </FormControl>
    </SurveyField>
    <SurveyField label="Minimum label"><FormControl placeholder="e.g. Poor" value={question.minLabel || ""} disabled={readOnly} onChange={(event) => update("minLabel", event.target.value)} /></SurveyField>
    <SurveyField label="Maximum label"><FormControl placeholder="e.g. Excellent" value={question.maxLabel || ""} disabled={readOnly} onChange={(event) => update("maxLabel", event.target.value)} /></SurveyField>
    <div className="survey-engine-fixed-rating">Fixed rating range: 1–5</div>
  </div>
);

export default RatingQuestionFields;
